module.exports = __webpack_public_path__ + "img/support-button.73f21cbb.png";